import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { DialogYearMonthComponent } from 'src/app/general-components/dialog-year-month/dialog-year-month.component';
import { NumAnnoMeseFilterComponent } from 'src/app/general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';
import { ConsuntivoVolumiScartoService } from 'src/app/monthly-actual/consuntivo-volumi-scarto/service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import { GenericArray } from 'src/models/GenericArray';
import { Offset } from 'src/models/Offset';
import { ProviderModel } from 'src/models/ProviderModel';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import { ScartiConsuntivoVolumiModel, ScartiConsuntivoVolumiReportModel } from 'src/models/ScartiConsuntivoVolumiModel';
import { BillingScartoService } from '../service-billing-scarto/billing-scarto.service';

@Component({
  selector: 'app-filter-billing-scarto',
  templateUrl: './filter-billing-scarto.component.html',
  styleUrls: ['./filter-billing-scarto.component.scss']
})
export class FilterBillingScartoComponent  extends BaseGeneralComponent implements OnInit, OnDestroy {

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;

  @Input() reportSection?: boolean;
  @Input() numAnnoMese?: number;
  @Input() numAnnoMeseData?: number;
  @Output() dataFiltered = new EventEmitter<any>();
  @Input() isRecovery?: boolean;

  regionCod: string;
  localCustomerCod: string;
  resourceUnitCod: string;
  designCod: string;
  contractTypeCod: string;
  shareName: string;
  applicationDescription: string;
  provider: ProviderModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  filter: ScartiConsuntivoVolumiModel;
  intermittentBool: boolean;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    }),
    responseType: 'application/csv'
  };
  constructor(private loaderService: LoaderService,
    private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
    private billingScartoService: BillingScartoService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog) {
      super();
    const providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    this.numAnnoMese = null;
    this.regionCod = null;
    this.localCustomerCod = null;
    this.resourceUnitCod = null;
    this.designCod = null;
    this.contractTypeCod = null;
    this.shareName = null;
    this.applicationDescription = null;
    this.provider = providerSelect;
     }

  ngOnInit() {
    this.filter = new ScartiConsuntivoVolumiModel();
    const lastMonth = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.numAnnoMese = Number(lastMonth.lastUploadedVolume);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
  }

  filterTable(): void {
    this.loaderService.display(true);

    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    this.numAnnoFilterComponent.reset();
    this.localCustomerCod = null;
    if(!this.provider.cod.includes('KYN')){
      this.regionCod = null;
    }
    this.resourceUnitCod = null;
    this.contractTypeCod = null;
    this.designCod = null;
    this.shareName = null;
    this.applicationDescription = null;
    this.filter.isRecovery = this.isRecovery;

    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.filterTable();
  }

  ngOnDestroy(): void {
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as any;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }

    this.loaderService.display(true);
    this.generateScartiVolumiXlsx(reportFilter);
  }

  generateScartiVolumiXlsx(reportFilter) {
    let fileName = 'Billing Errors';
    
    this.getNameSubscribe = this.billingScartoService.getNameGenerateXlsx(this.offset, reportFilter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate  + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI_SCARTO}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomerCod = this.localCustomerCod ? this.localCustomerCod : '';
    // this.filter.resourcesUnitCod = this.resourceUnitCod ? this.resourceUnitCod : '';
    this.filter.contractCod = this.contractTypeCod ? this.contractTypeCod : '';
    if(!this.provider.cod.includes('KYN')){
      this.filter.regionCod = this.regionCod ? this.regionCod : '';
    }
    // this.filter.designCod = this.designCod ? this.designCod : '';
    // this.filter.shareName = this.shareName ? this.shareName : '';
    // this.filter.applicationDescription = this.applicationDescription ? this.applicationDescription : '';
    // this.filter.providerCod = this.providerCod ? this.providerCod : '';
    this.filter.provider = this.provider;
    this.loaderService.display(false);
  }

  interceptNumAnnoMeseChange(event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptProviderChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptContractTypeChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRegionChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptLocalCustomerChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptResourceUnitChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptSl1Change(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptSharenameChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptApplicationDescChange(value: string) {
    if (!this.reportSection) {
      if (value == '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

}
